<template>
  <div class="channel">
    <div class="page-header">
      <i class="back-icon" @click="$router.go(-1)"></i>
      <span>{{ moreTitle }}</span>
    </div>
    <InfiniteScroll :load="loadMore" :loading="loading">
      <List :data="data" :displayStyle="4" @goDetail="goDetail" />
    </InfiniteScroll>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import List from '@/components/List';
import { getNovelChapters, getChannelData } from '@/api';
import InfiniteScroll from '@/components/InfiniteScroll';

export default {
  components: { List, InfiniteScroll },
  created() {
    this.init();
  },
  watch: {
    '$route': {
      handler() {
        this.init();
      },
    },
  },
  computed: {
    ...mapState(['moreTitle']),
  },
  data() {
    return {
      data: [],
      loading: false,
      obj: {
        page: 1,
        per_page: 5,
      },
      hasMore: true,
    };
  },
  methods: {
    init() {
      this.getChannel();
    },
    async goDetail(novelId) {
      const res = await getNovelChapters(novelId);
      if (res.code !== 0) return;
      const { id = '' } = res.data[0];
      this.$router.push(`/novel/${novelId}/chapter/${id}`);
    },
    async getChannel(type = '') {
      const { params: { id } } = this.$route || {};
      const res = await getChannelData(id, { ...this.obj });
      if (res.code !== 0) return;
      const { list = [], has_next = false, current_page = 1 } = res?.data || {};
      type === 'more' ? this.data.push(...list) : this.data = list;
      this.hasMore = has_next;
      this.obj.page = current_page + 1;
    },
    loadMore() {
      if (!this.hasMore) {
        this.$toast.error('no more comics...');
      } else {
        this.getChannel('more');
      }
    },
  },
};
</script>
<style lang="less" scoped>
.channel {
  background-size: 100%;
  min-height: 100vh;
  padding-bottom: 16px;
  .page-header {
    display: flex;
    align-items: center;
    color: @black;
    font-size: @fontLarge;
    font-weight: 700;
    height: 44px;
    padding: 0 16px;
    .back-icon {
      margin-right: 10px;
      .iconMixin({
        background-image: url('~@/assets/images/icon/back.png');
      });
    }
  }
}
</style>
